import request from '../../../../../helpers/request';

export const key = ({ companyId, cityId }) => [
  'shutdownCompanyHouses',
  companyId,
  cityId,
];

const shutdownCompanyHousesQuery = async ({ queryKey }) => {
  const [_, companyId, cityId] = queryKey;

  return await request.get(
    `/Request/houses`,
    { companyId, cityId },
    'При загрузке списка домов для выбранной компании произошла ошибка'
  );
};

export const fetchCompanyHouses = async ({ queryClient, params, options }) =>
  await queryClient.fetchQuery(
    key(params),
    shutdownCompanyHousesQuery,
    options
  );
